import { ItemFinderListView } from "../../ItemFinderListView";
import { ListColumn } from "../ListColumn";
import { ListView } from "../ListView"

export class MedicinalProductsListView extends ItemFinderListView{

    constructor(items: any, itemFinderArrayColumns:ListColumn[], itemFinderTreeColumns:ListColumn[]) {
        super(items,itemFinderArrayColumns,itemFinderTreeColumns);
    }

}